document.addEventListener('DOMContentLoaded', function () {
  // Both the base AND the path come from document.baseURI: inside a srcdoc
  // iframe (the builder canvas) location.origin is the string "null" and
  // location.pathname is "srcdoc". baseURI inherits the parent page's URL
  // there, and equals the page URL everywhere else.
  const currentPath = new URL(document.baseURI).pathname

  document.querySelectorAll('a[href*="rw.rw"]').forEach(function (link) {
    const rawHref = link.getAttribute('href')

    if (!rawHref) return

    // Resolve against document.baseURI, not window.location.origin: inside a
    // srcdoc iframe (the builder's section canvas) location.origin is the
    // string "null", which is not a valid base — the URL constructor threw and
    // aborted this whole listener for every section carrying an rw.rw link.
    // baseURI inherits the parent page's URL there, and equals the page URL
    // everywhere else. A malformed href skips its own link only.
    let url
    try {
      url = new URL(rawHref, document.baseURI)
    } catch (_e) {
      return
    }

    if (!url.searchParams.has('originpath')) {
      url.searchParams.set('originpath', currentPath)
      link.href = url.toString()
    }
  })
})
